// 计算任务选择
<template>
  <div class="home net-status-home">
    <Layout
      layoutType="HARDLIST"
      isRevenue="true"
      :pageTitle="$t('menu.calTask')"
    >
      <Tips
        :title="$t('tips.title')"
        :tips="$t('tips.detail')"
        class="withdrawal-tips"
      />
      <!-- 任务解释 -->
      <FAQ />
      <BasiceLayout
        class="task-list-wrap"
        :title="$t('menu.calTask')"
      >
        <div class="hardware-content">
          <!-- mac地址搜索 -->
          <div
            class="hardware-search-wrap"
            align='center'
          >
            <span class="search-text">{{$t('noteSearch')}}</span>
            <el-input
              class="search-mac-input"
              v-model="searchNote"
              @change="search(searchNote)"
            ></el-input>
            <!-- 批量操作 -->
            <div class="unbind-more-button">
              <!-- <div
                type="danger"
                @click="changeMultStatus(true)"
                v-bind:class="[{'background-ddd': multipleStatus}, 'button', 'bonus-cursor']"
              >批量选择</div> -->
              <!-- <div
                type="danger"
                v-if="multipleStatus"
                @click="changeMultStatus(false)"
                class=" unbind-button bonus-cursor "
              >{{ $t('cancel') }}</div> -->
              <!-- <div
                type="danger"
                v-if="multipleStatus"
                @click="dealMultDevices()"
                class="button bonus-cursor"
              >{{ $t('sure') }}</div> -->
            </div>
          </div>
          <!-- 硬件列表 -->
          <el-table
            v-if="hardList !== 'NO_CONTENT'"
            :data="hardList"
            align="left"
            empty-text="Loading..."
            style="width: 100%"
            @sort-change="sortDevices"
          >
            <!-- @selection-change="handleSelectionChange" -->
            <!-- ref="multipleTable" -->

            <!-- 多选列表  -->
            <el-table-column
              v-if="multipleStatus"
              type="selection"
              width="55"
              :selectable="checkSelectable"
            >
            </el-table-column>
            <!-- mac address -->
            <el-table-column
              prop="mac_address"
              :label="$t('mac_address')"
              align='center'
            >
            </el-table-column>
            <!-- 备注 -->
            <el-table-column
              :label="$t('noteText')"
              align='center'
              sortable="custom"
            >
              <template slot-scope="scope">
                <div v-if="scope.row.note">{{scope.row.note}}</div>
                <div
                  v-if="!scope.row.note"
                  :deviceId="scope.row.deviceId"
                  @click="showNotes(scope.row.id, scope.row.mac_address)"
                  class="add-note-button button bonus-cursor"
                >
                  {{$t('addNote')}}</div>
                <i
                  v-if="scope.row.note && scope.row.noteStatus"
                  class="el-icon-edit"
                  @click="showNotes(scope.row.id, scope.row.mac_address)"
                ></i>
              </template>
            </el-table-column>
            <!-- cpu -->
            <el-table-column
              :label="$t('CPU')"
              align='center'
            >
              <template slot-scope="scope">
                <div v-if="scope.row.cpu_count">{{scope.row.cpu_count}}</div>
                <div v-else>-</div>
              </template>
            </el-table-column>
            <!-- 内存 -->
            <el-table-column
              prop=""
              :label="$t('mem_size')"
              align='center'
            >
              <template slot-scope="scope">
                <div v-if="scope.row.mem_size">{{scope.row.mem_size}}</div>
                <div v-else>-</div>
              </template>
            </el-table-column>
            <!-- 硬盘 -->
            <el-table-column
              prop=""
              :label="$t('storage_size')"
              align='center'
            >
              <template slot-scope="scope">
                <div v-if="scope.row.storage_size">{{scope.row.storage_size}}</div>
                <div v-else>-</div>
              </template>
            </el-table-column>
            <!-- 当前任务 -->
            <el-table-column
              :label="$t('currentRunningTask')"
              align='center'
            >
              <template slot-scope="scope">
                <div v-if="scope.row.task_map && scope.row.task_map.length" v-for="(item, index) in scope.row.task_map">
                  <span>{{ item.task }} </span>
                </div>
                <div v-else>-</div>
              </template>
            </el-table-column>
            <!-- 选择切换任务类型 -->
            <el-table-column
              :label="$t('changeTask')"
              align='center'
            >
              <template slot-scope="scope">
                <!-- <div v-for="(item, index) in scope.row.manual_schedule_candidate">{{item}} {{index}}</div> -->
                <div v-if="scope.row.manual_schedule_status === 'ARLEADT_SCHEDULE'">2小时内操作过</div>
                <div v-else-if="scope.row.manual_schedule_status === 'ERROR_CONIFIG'">配置不符合要求</div>
                <div
                  v-else
                  v-bind:class="[{'background-ddd': multipleStatus}, 'button']"
                  @click="changeTask(scope.row, scope.$index)"
                >选择任务</div>
                <!-- <el-select
                  v-else
                  :disabled="multipleStatus"
                  v-model="schduleType[scope.$index]"
                  @change="changeTask(scope.row, scope.$index)"
                >
                  <el-option
                    v-for="(item, index) in scope.row.manual_schedule_candidate"
                    :key="item"
                    :label="index"
                    :value="item"
                  >
                  </el-option>
                </el-select> -->
                <!-- <div v-else>-</div> -->
              </template>
            </el-table-column>
          </el-table>
          <div
            class="pagination"
            v-if="deviceSize > 1"
          >
            <el-pagination
              @current-change="handleCurrentChange"
              :current-page.sync="currentPage"
              :page-size="deviceSize"
              layout="total, prev, pager, next"
              :total="hardLength"
            >
            </el-pagination>
          </div>
          <el-table
            v-if="hardList === 'NO_CONTENT'"
            :empty-text="$t('noHardwareTip')"
            style="width: 100%"
          >
          </el-table>
        </div>
      </BasiceLayout>

    </Layout>

    <!-- 任务调度提示 -->
    <el-dialog
      title="任务切换"
      :visible.sync="showScheduleDialog"
      center
      :before-close="cancelChooseSchedule"
    >
      <!-- <div class="unbind-dialog-wrap cal-tast-tips">
        根据业务方要求，A任务每月5日-25日无法调度，请谨慎删除
      </div> -->
      <div class="cal-task-change">
        <div class="cal-change-item">
          <div class="mac">设备</div>
          <div class="mac">当前任务</div>
          <div class="mac">操作</div>
        </div>
        <div
          class="cal-change-item"
        >
          <div class="mac ">{{changeDevice.mac_address}}</div>
          <div class="mac">
            <div v-if="changeDevice.task_map" v-for="item in changeDevice.task_map">{{item.task}}</div>
          </div>
          <div class="mac">
            <div class="bonus-cursor bonus-color" v-if="changeDevice.task_map" v-for="itemIntance in changeDevice.task_map" @click="deleteSchedule(itemIntance.id)">
              删除
            </div>
          </div>
        </div>
        <div class="border"></div>
        <div class="cal-task-change">
          <div class="cal-change-item">
            <div class="mac">
              任务
            </div>
            <div class="mac">
              任务数量选择
            </div>
            <div class="mac">
              每任务使用硬盘空间
            </div>
            <div class="mac">
              操作
            </div>
          </div>
          <div class="cal-change-item">
            <div class="mac">
              <el-select
                v-model="choosedType"
              >
                <!-- @change="changeType(index)" -->
                <el-option
                  v-for="item in changeType"
                  :key="String(item)"
                  :label="String(item)"
                  :value="String(item)"
                >
                </el-option>
              </el-select>
              <!-- <div class="bonus-tips">D任务当前测试名额已满</div> -->
            </div>
            <div class="mac">
              <el-select
                v-model="choosedTask"
              >
                <!-- @change="changeType(index)" -->
                <el-option
                  v-for="item in changeTypeTask[choosedType]"
                  :key="String(item)"
                  :label="String(item)"
                  :value="String(item)"
                >
                </el-option>
              </el-select>
            </div>
            <div class="mac">
              <el-select
                v-model="choosedZone"
              >
                <!-- @change="changeType(index)" -->
                <el-option
                  v-for="item in  changeZone[choosedType + '-' + choosedTask]"
                  :key="String(item)"
                  :label="String(item)"
                  :value="String(item)"
                >
                </el-option>
              </el-select>
            </div>
            <div class="mac bonus-color" @click="updateSchedule">
              {{changeDevice.alreadyHasTaskType && changeDevice.alreadyHasTaskType.includes(choosedType) ? '替换' : '增加'}}
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

    <!--  任务切换 -->
    <el-dialog
      title="任务切换"
      :visible.sync="showUpdateDial"
      center
    >
      <div>
        注：切换任务可能会导致硬盘现有数据丢失（修改单任务使用硬盘空间一定会清理现有数据），需要重新进行 5-7 天的数据同步。
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <div
          class="sure-unbind button"
          type="primary"
          @click="changeSchedule('update')"
        >{{ $t('sure') }}</div>
        <div
          class="unbind-button"
          @click="showUpdateDial = false"
        >{{ $t('cancel') }}</div>
      </div>
    </el-dialog>
    <!--  删除任务 -->
    <el-dialog
      title="删除任务"
      :visible.sync="showDeleteDial"
      center
      :before-close="cancelChooseSchedule"
    >
      <div>
        是否删除任务？（根据业务方要求，A任务每月5日-25日无法调度，请谨慎删除）
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <div
          class="sure-unbind button"
          type="primary"
          @click="changeSchedule('delete')"
        >{{ $t('sure') }}</div>
        <div
          class="unbind-button"
          @click="showDeleteDial = false"
        >{{ $t('cancel') }}</div>
      </div>
    </el-dialog>
  </div>
</template>

<i18n>
{
  "en": {
    "noteSearch": "Note",
    "currentRunningTask": "Current running task",
    "changeTask": "选择切换任务类型",
    "tips": {
      "title": "注意事项",
      "detail": [
        "1. 选择任务或删除任务后，会进入任务切换状态，整个过程需要2小时，请耐心等待切换结束后再进行下一步操作。",
        "2.选择切换任务时，系统会根据所选择设备的硬件配置，给出可以选择的任务类型。",
        "3.进行任务切换会导致硬盘现有数据丢失，需要重新进行数据同步。",
        "4.不论设备运行何种任务，不同设备的数据盘互换会导致硬盘数据被清空，需要重新进行同步。",
        "5.请勿频繁操作切换任务类型，可能会导致设备无法正常工作。",
        "6.提交切换申请后，请保持设备稳定在线，网络通畅，否则会切换不成功导致调度失败。",
        "7.设备对应任务运行数量及推荐配置：<router-link>https://bonuscloud.club/viewtopic.php?f=15&t=12#p23455<router-link>"
      ]
    },
    "calType": [
      "网络要求：所有任务均推荐三大运营商网络。",
      "稳定性要求：所有任务均需要保证在其特定的高峰期稳定在线，否则会影响收益。",
      "&nbsp;",
      "<special>A任务<special> （推荐新手选择）",
      "（1）全天工作任务，开放选择时间为每月26日到次月5日，选择任务后需要7天时间同步数据才可正常运行。",
      "（2）每日0：00-10：00为数据同步时间，数据同步时间宕机会影响后续几天运行情况。",
      "（3）每日18：00-24：00为晚高峰时间，晚高峰宕机会影响收益权重导致当日收益下降。",
      "（4）A任务推荐使用IO性能较好的固态硬盘作为数据盘，机械盘上限较低。",
      "&nbsp;",
      "<special>B任务<special>",
      "（1）每日工作时间为晚高峰。",
      "（2）晚高峰外其余时间不定期同步数据。",
      "（3）每日18：00-24：00为晚高峰时间，晚高峰宕机会影响收益权重导致当日收益下降。",
      "（4）B任务对硬盘IO性能要求较低，可以使用机械硬盘，该任务连接数较多，请谨慎选择。",
      "&nbsp;",
      "<special>C任务<special>",
      "（1）全天工作任务，不限制选择时间，选择后需要2-3天时间同步数据才可正常运行。",
      "（2）全天不定时同步数据。",
      "（3）每日18：00-24：00为晚高峰时间，晚高峰宕机会影响收益权重导致当日收益下降。",
      "（4）C任务对硬盘IO性能要求较低，可以使用机械硬盘。",
      "&nbsp;",
      "<special>D任务<special>",
      "（1）全天工作任务。",
      "（2）全天不定时同步数据。",
      "（3）每日18：00-24：00为晚高峰时间，晚高峰宕机会影响收益权重导致当日收益下降。",
      "&nbsp;",
      "<special>F任务<special> ",
      "（1）每日工作时间为午高峰及晚高峰。",
      "（2）高峰外其余时间不定期同步数据。",
      "（3）F任务推荐使用IO性能较好的固态硬盘作为数据盘，机械盘上限较低。该任务连接数较多，可能导致光猫或路由器崩溃，请谨慎选择，或限制连接数上限。",
      "（4）F任务需要任务和线路NAT1固定映射，一一对应，不支持upnp。",
      "&nbsp;",
      "<special>H任务<special> ",
      "（1）支持全国所有地区及运营商",
      "（2）每个任务线程要求1核/1G/50G硬盘起，硬盘推荐使用固态，机械看具体性能",
      "（3）每个任务线程需要对应一条线路，出口IP 24小时内只允许发生一次拨号变更，不可重复变更，否则无法调度（具体软路由设置源IP等）",
      "（4）必须有NAT1或者UPNP（推荐NAT1），否则无法调度，如果出口IP变化频繁，也会导致无法实现NAT1",
      "&nbsp;",
      "<special>I任务<special> ",
      "（1）支持全国所有地区及运营商",
      "（2）每个任务线程要求1核/1G/100G硬盘起，硬盘推荐使用固态，机械看具体性能",
      "（3）电信联通必须有公网IP，移动必须有NAT1",
      "（4）该任务为全天运行，不定时同步数据。"
    ]
  },
  "zn": {
    "noteSearch": "备注",
    "changeTask": "选择切换任务类型",
    "currentRunningTask": "当前运行任务",
    "tips": {
      "title": "注意事项"
    }
  }
}
</i18n>


<script>
// @ is an alias to /src
import { mapState, mapActions, mapMutations } from "vuex";
import BasiceLayout from "@/components/Common/BasicLayout.vue";
import HardwareLayout from "@/components/Hardware/HardwareLayout.vue";
import { LANG } from "../../../config/contant.js";
import Layout from "@/components/DatePanel/Layout.vue";
import Tips from "@/components/Common/Tips.vue";
import { Message } from "element-ui";
import moment from "moment";
import FAQ from '@/components/DatePanel/RunTaskFAQ.vue' //任务解释

export default {
  name: "home",
  components: {
    BasiceLayout,
    HardwareLayout,
    Layout,
    Tips,
    FAQ
  },
  data() {
    return {
      searchMacAddress: "",
      searchNote: "",
      schduleType: [],
      filterType: "calculate",
      type: "compute",
      manual_schedule: true,
      showScheduleDialog: false,
      // changeDeviceId: "",
      changeInstanceId: "",
      multipleStatus: false, //多选状态
      multipleSelection: [], //选中的多个解绑设备
      response: [],
      // alreadyCommit: false,
      chooseSchedule: [], //选中的任务数量
      // chooseScheduleList: [], //选中的任务数量列表
      chooseCache: [], //选中的硬盘空间
      chooseCacheList: [], //选列表
      canChooseCache: {},
      changeDevice: "", //切换任务的mac
      changeType: [], 
      changeTypeTask: {}, 
      changeZone: {},
      choosedType: "",
      choosedTask: "",
      choosedZone: "",
      showUpdateDial: false,
      showDeleteDial: false,
      delete_instance_id: ""
    };
  },
  computed: mapState({
    // hardList: state => state.hardWare.list,
    deviceSize: state => state.hardWare.deviceSize,
    hardLength: state => state.hardWare.hardLength,
    currentPage: state => state.hardWare.currentPage,
    hardList: state => state.hardWare.list,
  }),
  methods: {
    ...mapActions(["getHardList", "changeTaskSchedule", "getDeviceDetail"]),
    updateSchedule() {
      this.showUpdateDial = true;
    },
    deleteSchedule(instance_id) {
      this.delete_instance_id =instance_id
      this.showDeleteDial = true;
    },
    // 切换
    changeSchedule(action_type) {
      // let { filterType, manual_schedule, type } = this;
      // let { multipleSelection, schduleType, filterType, manual_schedule } = this;
      let { choosedType, choosedTask, choosedZone, changeDevice, manual_schedule, filterType, type, currentPage } = this;

      let changeArray = [], noChoosed = false;
      // multipleSelection.map((item, index) => {

        if (action_type === 'update' && choosedTask && choosedType && choosedZone ) {

          let instance_id = changeDevice.manual_schedule_candidate[`${choosedType}-${choosedTask}-${choosedZone}`];
          changeArray.push({
            device_id: changeDevice.id,
            bcode: changeDevice.bcode,
            instance_id,
            mac_address: changeDevice.mac_address,
            action_type,
            choosedType, 
            choosedTask, 
            choosedZone
          });
        } else if (action_type === 'delete' && this.delete_instance_id) {
          changeArray.push({
            device_id: changeDevice.id,
            bcode: changeDevice.bcode,
            instance_id: this.delete_instance_id,
            mac_address: changeDevice.mac_address,
            action_type
          });
        } else {
          noChoosed = `任务未选择`;
        }
      // });

      if (noChoosed.length) {
        return Message({
          type: "error",
          message: noChoosed
        });
      } else {
        // let { changeInstanceId } = this;
        this.changeTaskSchedule({
          changeArray
        }).then(res => {
          if (res && res[0] && res[0].status && res[0].status == 'success') {
            this.showDeleteDial = false;
            this.showUpdateDial = false;
            this.showScheduleDialog = false;
            // this.alreadyCommit = true;
            // this.response = res;
            Message({
              type: "success",
              message: "操作成功"
            });

            this.getHardList({ pageNum: currentPage, manual_schedule, filterType, type });
          } else {
            Message({
              type: "error",
              message: res[0].message || "操作失败"
            });
          }
        });
      }
    },
    // 显示切换任务提示对话框
    changeTask(item, index) {
      this.changeDeviceId = item.id;
      this.changeDevice = item;

      let changeType = [], changeTypeTask = {}, changeZone = {};
      if (item.manual_schedule_candidate) {
        for (var list in item.manual_schedule_candidate) {
          let choose = list.split('-');

          // 任务数量选择
          let startTime = moment().startOf('month').add(4, 'd').valueOf();
          let endTime =  moment().startOf('month').add(25, 'd').valueOf();
          // let noAdd = moment().isBetween(startTime, endTime);
          let noAdd = false;

          // 在每月26号0-次月5日0点，可以新增可以替换
          // 每月5日0点到25日23：59分 有A任务可以替换，不可新增
          if (true) {
          // if (!(choose[0] === 'A' && noAdd && !this.changeDevice.alreadyHasTaskType.includes('A'))) {
            !changeType.includes(choose[0]) && changeType.push(choose[0]);

            if (changeTypeTask[choose[0]]) {
              if (!changeTypeTask[choose[0]].includes(choose[1])) {
                changeTypeTask[choose[0]].push(choose[1])
              }
            } else {
              changeTypeTask[choose[0]] = [choose[1]]
            }
            // 使用空间列表选择
            if (changeZone[`${choose[0]}-${choose[1]}`]) {
              if (!changeZone[`${choose[0]}-${choose[1]}`].includes(choose[2])) {
                changeZone[`${choose[0]}-${choose[1]}`].push(choose[2])
              }
            } else {
              changeZone[`${choose[0]}-${choose[1]}`] = [choose[2]]
            }
          }
         
        }
      }
      this.changeType = changeType;
      this.changeTypeTask = changeTypeTask;
      this.changeZone = changeZone;
      this.showScheduleDialog = true;
      this.choosedType = "";
      this.choosedTask = "";
      this.choosedZone = "";
    },
    // 排序
    sortDevices() {
      let { filterType, currentPage, type, manual_schedule } = this;
      let deviceOrder = "note";
      this.deviceOrder = deviceOrder;
      this.getHardList({
        filterType,
        pageNum: currentPage,
        deviceOrder,
        type,
        manual_schedule
      });
    },
    // 分页
    handleCurrentChange(val) {
      this.currentPage = val;
      let { deviceOrder, filterType, manual_schedule, type } = this;

      this.getHardList({
        pageNum: val,
        filterType,
        deviceOrder,
        manual_schedule,
        type
      });
    },
    // 搜索
    search(value) {
      let { filterType, manual_schedule, type } = this;
      this.getDeviceDetail({ note: value, filterType, manual_schedule, type });
    },
    // 进入批量选择状态
    // changeMultStatus(status) {
    //   this.multipleStatus = status;
    //   this.multipleSelection = [];
    //   // this.schduleType = [];
    //   this.response = [];
    //   this.alreadyCommit = false;
    //   this.chooseCache =[];
    //   this.chooseSchedule = [];

    //   // 取消选择
    //   if (!status) {
    //     this.$refs.multipleTable.clearSelection();
    //   }
    // },
    // 处理多个设备选择
    // dealMultDevices() {
    //   // 处理为选中状态
    //   if (!this.multipleSelection.length) {
    //     return Message({
    //       message: "无切换任务的设备",
    //       type: "error"
    //     });
    //   }
    //   this.showScheduleDialog = true;
    // },
    // 多选选择
    // handleSelectionChange(val) {
    //   this.multipleSelection = val;
    // },
    // changeSelected(index) {
    //   console.log(index);
    //   let {
    //     chooseSchedule,
    //     canChooseSchedule,
    //     chooseCacheList
    //   } = this;
    //   // 选中
    //   let schedule = chooseSchedule[index];
    //   let canCache = canChooseSchedule[index];
      
    //   this.chooseCacheList[index] = canCache[schedule];
    // },
    cancelChooseSchedule() {
      this.showUpdateDial = false
      this.showScheduleDialog = false;
      this.choosedType = "";
      this.choosedTask = "";
      this.choosedZone = "";
    //   this.chooseCache =[];
    //   this.canChooseSchedule = [];
    //   this.chooseSchedule = [];
    //   this.alreadyCommit = false;
    //   this.response = '';
    },
    checkSelectable (row, index) {
      //通过id来禁止不能选择的项
      // return row.id !== 1
      //通过索引index来禁止不能选择的项
      return row.manual_schedule_status !== 'ARLEADT_SCHEDULE' && row.manual_schedule_status !== 'ERROR_CONIFIG'
    }
  },
  created() {
    let { filterType, manual_schedule, type } = this;

    // manual_schedule为true时可列出可调度列表
    this.getHardList({ pageNum: 1, manual_schedule, filterType, type });
  }
};
</script>

<style lang="stylus">
.task-list-wrap {
  margin-top: 20px;
}

.pagination {
  margin: 20px;
}

.hardware-search-wrap {
  text-align: left;
  margin-bottom: 20px;
  padding-bottom: 30px;
  border-bottom: 1px solid #ddd;
}

.search-text {
  margin: 0 20px;
  display: inline-block;
}

.addnote-input {
  width: 100%;
  margin-top: 20px;
}

.add-note-button {
  background: #909399;
  color: #fff;
  width: 110px;
  height: 35px;
  line-height: 35px;
  text-align: center;
  margin: 0;
  width: 100%;
}

.net-status-home.home {
  height: auto !important;
}

.el-table th div {
  overflow: initial !important;
}

.cal-change-item {
  margin: 20px;
  display: flex;
  justify-content: center;

  .mac {
    line-height: 40px;
    margin-right: 20px;
    width: 33%;
    // padding: 0 20px;
    text-align: center;
  }
}

.cal-tast-tips{
  padding: 0 60px;
  font-size: 14px;
  font-weight: bold;

}
</style>
